export const initiatives = [
  {
    id: 'nomoresscamcalls',
    name: 'NoMoreScamCalls',
    description: 'Our flagship anti-scam call screening service protecting families from phone scams through education, awareness campaigns, and technological solutions that identify and block fraudulent callers.',
    status: 'active',
    color: 'blue',
    icon: 'PhoneOff',
    url: '#',
  },
  {
    id: 'scaminaters',
    name: 'Scaminaters',
    description: 'Tools and services for businesses and individuals to fight scams and share experiences.',
    status: 'future',
    color: 'slate',
    icon: 'Shield',
    url: '#',
  },
  {
    id: 'textinaters',
    name: 'Textinaters',
    description: 'SMS-based scam detection and reporting system for text-based fraud.',
    status: 'future',
    color: 'slate',
    icon: 'MessageSquare',
    url: '#',
  },
  {
    id: 'emailinaters',
    name: 'Emailinaters',
    description: 'Email security education and phishing detection tools.',
    status: 'future',
    color: 'slate',
    icon: 'Mail',
    url: '#',
  },
  {
    id: 'webinaters',
    name: 'Webinaters',
    description: 'Educational webinars teaching families how to stay safe online.',
    status: 'future',
    color: 'slate',
    icon: 'Video',
    url: '#',
  },
  {
    id: 'spaminaters',
    name: 'Spaminaters',
    description: 'Comprehensive spam filtering and prevention solutions.',
    status: 'future',
    color: 'slate',
    icon: 'Ban',
    url: '#',
  },
  {
    id: 'scamcallblocker',
    name: 'ScamCallBlocker',
    description: 'Advanced call blocking technology for known scam numbers.',
    status: 'future',
    color: 'slate',
    icon: 'PhoneOff',
    url: '#',
  },
];

export const getActiveInitiatives = () => {
  return initiatives.filter(init => init.status === 'active');
};

export const getFutureInitiatives = () => {
  return initiatives.filter(init => init.status === 'future');
};

export const getInitiativeByStatus = (status) => {
  return initiatives.filter(init => init.status === status);
};
